<template>
  <div class="main">
    <div class="head-title">
      <div class="left">
        <div @click="$router.back()" class="name">
          {{ userInfo && userInfo.teacher_name }}
        </div>
        <div class="icon">></div>
        <div class=" blue">
          我的
        </div>
      </div>
    </div>
    <div class="content flex-row">
      <div class="tx">
        <img :src="userInfo && userInfo.head_img" alt="" />
        <div
          class="unbind"
          :class="userInfo && userInfo.openid ? 'active' : ''"
        >
          {{ userInfo && userInfo.openid ? "已绑定微信" : "未绑定微信" }}
        </div>
      </div>
      <div class="msg">
        <div class="cell">姓名：{{ userInfo && userInfo.teacher_name }}</div>
        <div class="cell">学校：{{ userInfo && userInfo.school_title }}</div>
        <div class="cell">班级：{{ userInfo && userInfo.class_name }}</div>
      </div>
    </div>
    <div class="head-title"></div>
    <div class="icons">
      <div @click="showCheckModal('changePwd')" class="item">
        <img src="../assets/chi.png" alt="" />
        <div class="name">修改密码</div>
      </div>
      <div @click="showCheckModal('changeMobile')" class="item">
        <img src="../assets/icon-b-03.png" alt="" />
        <div class="name">修改手机号</div>
      </div>
    </div>
    <a-modal
      :visible="checkModal"
      centered
      footer=""
      @cancel="checkModal = false"
      width="380px"
    >
      <div class="modal2">
        <div class="head">
          <img class="logo" :src="require('../assets/logo.png')" alt="" />
          <div class="msg">
            <div class="title">身份验证</div>
          </div>
        </div>
        <div class="form">
          <div class="item">
            <div class="left">
              <div v-if="userInfo" class="label">
                发送信息到{{
                  userInfo.mobile.substr(0, 3) +
                    "***" +
                    userInfo.mobile.substr(-3, 3)
                }}验证
              </div>
              <div class="inputbox">
                <input
                  v-model="checkForm.verify"
                  placeholder="请输入验证码"
                  type="text"
                />
                <div @click="getCode" class="getcode">
                  {{ countDown > 0 ? countDown + "s" : "获取验证码" }}
                </div>
              </div>
            </div>
            <div @click="checkCode" class="btn">
              确认
            </div>
          </div>
          <div class="item">
            <div class="left">
              <div class="label">密码验证</div>
              <div class="inputbox">
                <input
                  v-model="password"
                  placeholder="请输入验证码"
                  type="text"
                />
              </div>
            </div>
            <div @click="checkPwd" class="btn">
              确认
            </div>
          </div>
        </div>
        <div v-if="checkState" class="check-msg">
          验证失败！请确认信息是否正确
        </div>
      </div>
    </a-modal>
    <a-modal
      :visible="changePwdModal"
      centered
      footer=""
      @cancel="changePwdModal = false"
      width="380px"
    >
      <div class="modal2">
        <div class="head">
          <img class="logo" :src="require('../assets/logo.png')" alt="" />
          <div class="msg">
            <div class="title">修改密码</div>
          </div>
        </div>
        <div class="form2" style="margin-top:8px">
          <a-form-model>
            <a-form-model-item label="新密码">
              <a-input v-model="pwdform.password" placeholder="请输入密码" />
            </a-form-model-item>
            <a-form-model-item label="确认密码">
              <a-input
                v-model="pwdform.re_password"
                placeholder="请再次确认密码"
              />
            </a-form-model-item>
          </a-form-model>
        </div>
        <ul class="ul">
          <li>密码需大于6位</li>
        </ul>
        <div class="btns">
          <a-button @click="changePwdModal = false">取消</a-button>
          <a-button @click="changePwd" type="primary">
            确认
          </a-button>
        </div>
      </div>
    </a-modal>
    <a-modal
      :visible="changeMobileModal"
      centered
      :closable="false"
      footer=""
      width="380px"
    >
      <div class="modal2">
        <div class="head">
          <img class="logo" :src="require('../assets/logo.png')" alt="" />
          <div class="msg">
            <div class="title">修改手机号</div>
          </div>
        </div>
        <div class="form2" style="margin-top:8px">
          <a-form-model>
            <a-form-model-item label="输入新手机号">
              <a-input
                v-model="mobileform.mobile"
                placeholder="请输入新手机号"
              />
            </a-form-model-item>
            <a-form-model-item label="输入验证码">
              <a-input-search
                placeholder="请输入验证码"
                v-model="mobileform.verify"
                @search="getCode2"
              >
                <a-button slot="enterButton" type="primary">
                  {{ countDown2 > 0 ? countDown2 + "s" : "获取验证码" }}
                </a-button>
              </a-input-search>
            </a-form-model-item>
          </a-form-model>
        </div>
        <div class="btns">
          <a-button @click="changeMobileModal = false">取消</a-button>
          <a-button @click="changeMobile" type="primary">
            确认
          </a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      changeMobileModal: false,
      checkModal: false,
      changePwdModal: false,
      code: "",
      password: "",
      checkState: false,
      checkForm: {
        mobile: "",
        verify_id: "",
        verify: "",
      },
      pwdform: {
        password: "",
        re_password: "",
      },
      mobileform: {
        mobile: "",
        verify_id: "",
        verify: "",
      },
      mode: "changePwd",
      countDown: 0,
      countDown2: 0,
    };
  },
  computed: {
    ...mapState(["headers", "userInfo"]),
  },
  created() {
    if (this.userInfo) {
      this.checkForm.mobile = this.userInfo.mobile;
    }
  },
  watch: {
    userInfo(val) {
      if (val) {
        this.checkForm.mobile = this.userInfo.mobile;
      }
    },
  },
  beforeDestroy() {
    if (this.time) clearTimeout(this.time)
    if (this.time2) clearTimeout(this.time2)
  },
  methods: {
    checkPwd() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.checkPwd,
        headers: { Authorization: this.$store.state.headers },
        data: { password: this.password },
      })
        .then((res) => {
          this.$message.info(res.data.msg);
          this.checkModal = false;
          if (res.data.status == 200) {
            this.password = "";
            if (this.mode == "changePwd") {
              this.changePwdModal = true;
            } else {
              this.changeMobileModal = true;
            }
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    showCheckModal(mode) {
      this.mode = mode;
      this.checkModal = true;
    },
    fcountDown() {
      this.time = setTimeout(() => {
        this.countDown--;
        if (this.countDown > 0) {
          this.fcountDown()
        }
      }, 1000);
    },
    fcountDown2() {
      this.time2 = setTimeout(() => {
        this.countDown2--;
        if (this.countDown2 > 0) {
          this.fcountDown2()
        }
      }, 1000);
    },
    getCode2() {
      if (!this.mobileform.mobile) {
        this.$message.error("请先填写手机号");
        return false;
      }
      if (this.countDown2 > 0) {
        this.$message.error("请"+this.countDown2 +"s后再试");
        return false;
      }
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.sendMsm,
        headers: { Authorization: this.$store.state.headers },
        data: { mobile: this.mobileform.mobile },
      })
        .then((res) => {
          this.$message.info(res.data.msg);
          if (res.data.status == 200) {
            this.countDown2 = 60 
            this.fcountDown2()
            this.mobileform.verify_id = res.data.key;
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    getCode() {
      if (!this.checkForm.mobile) {
        this.$message.error("请先填写手机号");
        return false;
      }
      if (this.countDown > 0) {
        this.$message.error("请"+this.countDown +"s后再试");
        return false;
      }
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.sendMsm,
        headers: { Authorization: this.$store.state.headers },
        data: { mobile: this.checkForm.mobile },
      })
        .then((res) => {
          this.$message.info(res.data.msg);
          if (res.data.status == 200) {
            this.countDown = 60
            this.fcountDown()
            this.checkForm.verify_id = res.data.key;
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    checkCode() {
      if (!this.checkForm.verify) {
        this.$message.error("请填写验证码");
        return false;
      }
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.checkCode,
        headers: { Authorization: this.$store.state.headers },
        data: this.checkForm,
      })
        .then((res) => {
          this.$message.info(res.data.msg);
          if (res.data.status == 200) {
            this.checkModal = false;
            this.checkForm = {
              mobile: this.userInfo.mobile,
              verify_id: "",
              verify: "",
            };
            setTimeout(() => {
              if (this.mode == "changePwd") {
                this.changePwdModal = true;
              } else {
                this.changeMobileModal = true;
              }
            }, 200);
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    changePwd() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.changePwd,
        headers: { Authorization: this.$store.state.headers },
        data: this.pwdform,
      })
        .then((res) => {
          this.$message.info(res.data.msg);
          if (res.data.status == 200) {
            this.pwdform = {
              password: "",
              re_password: "",
            };
            this.changePwdModal = false;
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    changeMobile() {
      this.$axios({
        method: "POST",
        url: this.$api.domain + this.$api.changeMobile,
        headers: { Authorization: this.$store.state.headers },
        data: this.mobileform,
      })
        .then((res) => {
          this.$message.info(res.data.msg);
          if (res.data.status == 200) {
            this.mobileform = {
              password: "",
              re_password: "",
            };
            this.changeMobileModal = false;
          }
        })
        .catch((res) => {
          this.$message.error(res.data.msg);
        });
    },
    show(e, id) {
      console.log(e, id);
    },
  },
};
</script>

<style lang="scss" scoped>
.ul {
  margin: 2px 0 12px 16px;
  padding: 0;
  li {
    font-size: 12px;
    color: #999;
  }
}
::v-deep
  .ant-input-search-enter-button
  input
  + .ant-input-group-addon
  .ant-input-search-button {
  border-radius: 0 30px 30px 0;
}
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 30px;
  .tx {
    width: 92px;
    height: 92px;
    position: relative;
    margin-right: 20px;
    .unbind {
      position: absolute;
      left: 6px;
      right: 6px;
      bottom: 0;
      height: 30px;
      line-height: 30px;
      border-radius: 30px;
      text-align: center;
      background: #f33900;
      font-size: 12px;
      color: #fff;
      &.active {
        background: #f33900;
      }
    }
    img {
      width: 100%;
      height: 100%;
      border-radius: 100px;
      background: #eee;
    }
  }
  .msg {
    .cell {
      color: #888;
      line-height: 1.9;
      font-size: 14px;
    }
  }
}
.icons {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  text-align: center;
  margin-top: 30px;
  .name {
    color: #787878;
    margin-top: 10px;
  }
  .item {
    margin-right: 30px;
    cursor: pointer;
  }
  img {
    width: 85px;
    height: 85px;
    border-radius: 55px;
  }
}
.main {
  width: 100%;
  height: 100%;
}
.list {
  width: 100%;
  margin-top: 20px;
  .head {
    width: 100%;
    display: flex;
    flex-direction: row;
    .left {
      width: 100px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: #f39800;
      color: #fff;
      margin: 0 1px 1px 0;
    }
    .right {
      display: flex;
      flex-direction: row;
      flex: 1 1 0%;
      .cell {
        width: 40px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #f39800;
        color: #fff;
        margin: 0 1px 1px 0;
      }
    }
  }
  .body {
    width: 100%;
    .students {
      display: flex;
      flex-direction: row;
      .left {
        width: 100px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        background: #e4eaee;
        color: #898989;
        margin: 0 1px 1px 0;
      }
      .right {
        flex: 1 1 0%;
        display: flex;
        flex-direction: row;
        .cell {
          width: 40px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          background: #e4eaee;
          color: #fff;
          margin: 0 1px 1px 0;
        }
      }
      &.hui .left {
        background: #dce2e6;
      }
      &.hui .right .cell {
        background: #dce2e6;
      }
    }
  }
}
.ewmbox {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-top: 30px;
  .ewm {
    width: 120px;
    height: 120px;
  }
  .msg {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 120px;
    padding: 10px;
    box-sizing: border-box;
    .txt {
      color: #f39800;
      font-size: 20px;
    }
    .see {
      cursor: pointer;
    }
  }
}
.head-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  .left {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    .main {
      font-size: 16px;
    }
  }
  .right {
    flex: 1 1 0%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    .msg {
      display: flex;
      flex-direction: row;
      align-items: center;
      .txt {
        margin-right: 3px;
      }
    }
  }
}
.frame-list {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
  margin-top: 30px;
  .addframe {
    width: 175px;
    margin-bottom: 30px;
    margin-right: 30px;
    cursor: pointer;
  }
  .addbox {
    width: 250px;
    height: 130px;
    border-radius: 0 20px 0 20px;

    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 3px dashed #67b0dc;
    cursor: pointer;
    .add {
      font-size: 40px;
    }
    .addtip {
      font-size: 20px;
      color: #67b0dc;
      margin-bottom: 16px;
    }
  }
  .cell {
    width: 175px;
    height: 120px;
    background: url("../assets/doc.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: row;
    padding: 25px 15px 15px 15px;
    margin-bottom: 30px;
    box-sizing: border-box;
    margin-right: 30px;
    .tx {
      width: 92px;
      height: 92px;
      margin-right: 20px;
    }
    &.select {
      border: 3px solid #67b0dc;
    }
    .msg {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .top {
        cursor: pointer;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #fff;
        font-size: 18px;
        img {
          width: 20px;
          margin-left: 10px;
        }
      }
      .foot {
        font-size: 14px;
        color: #fff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        .order {
          font-size: 30px;
          line-height: 1;
        }
      }
    }
  }
}
.btns {
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  justify-content: flex-end;
  .ant-btn {
    margin-left: 20px;
  }
}
::v-deep .ant-btn-primary {
  color: #fff;
  background-color: #67b0dc;
  border-color: #67b0dc;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
::v-deep .ant-form-item {
  margin-bottom: 10px;
}
::v-deep .ant-input {
  border-radius: 24px;
  transition: all 0.3s;
}
</style>
